export const RATIOVALUEFORMATOVERVIEWCARDMETRIC = ['D1','Retention D 1','Retention D2','D7'];
